module.exports = __webpack_public_path__ + "img/p7.b17c8b8c.png";